module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/strong_point/6_778f28c9262f569fe6bc43f0cdafd133.png";